module.exports = __webpack_public_path__ + "img/1_m.18807791.jpg";